import axiosInstance from "../libs/axiosInstance";

// Create a new university
export const createUniversity = async (universityData) => {
  try {
    const response = await axiosInstance.post('/course_management/universities/', universityData);
    return response.data;
  } catch (error) {
    console.error('Error creating university:', error);
    throw error;
  }
};

// Get all universities
export const getUniversities = async () => {
  try {
    const response = await axiosInstance.get('/course_management/universities/');
    return response.data;
  } catch (error) {
    console.error('Error fetching universities:', error);
    throw error;
  }
};

// Update a university
export const updateUniversity = async (universityId, universityData) => {
  try {
    const response = await axiosInstance.put(`/course_management/universities/${universityId}/`, universityData);
    return response.data;
  } catch (error) {
    console.error('Error updating university:', error);
    throw error;
  }
};

// Delete a university
export const deleteUniversity = async (universityId) => {
  try {
    await axiosInstance.delete(`/course_management/universities/${universityId}/`);
  } catch (error) {
    console.error('Error deleting university:', error);
    throw error;
  }
};
